import React from 'react';
import { StatusChip } from '../StatusChip';
import type { EntityType } from '../StatusChip/config';

interface StatusCellProps {
  value?: unknown;
  entityType?: EntityType;
  status?: string;
  render?: () => React.ReactNode;
  // Allow override of StatusChip props
  color?: React.ComponentProps<typeof StatusChip>['color'];
  variant?: React.ComponentProps<typeof StatusChip>['variant'];
  size?: 'xsmall' | 'small' | 'medium' | 'large';
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  label?: string;
  className?: string;
}

function StatusCell({
  value,
  entityType,
  status,
  render,
  color,
  variant,
  size = 'small',
  startIcon,
  endIcon,
  label,
  className,
}: StatusCellProps) {
  if (render) {
    return <>{render()}</>;
  }

  // Determine status from value or prop
  const finalStatus = status ?? (value ? String(value) : undefined);

  if (!finalStatus) {
    return null;
  }

  return (
    <StatusChip
      entityType={entityType}
      status={finalStatus}
      color={color}
      variant={variant}
      size={size}
      startIcon={startIcon}
      endIcon={endIcon}
      label={label}
      className={className ? `data-cell__status ${className}` : 'data-cell__status'}
    />
  );
}

export default StatusCell;

export function StatusCellSkeleton() {
  return (
    <div className="data-cell__status-skeleton">
      <div className="skeleton skeleton--badge" />
    </div>
  );
}

